<template>
  <div>
    <v-dialog v-model="dialog" class="w-full md:w-1/2">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="close">cancel</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="px-2">
            <div
              class="flex flex-wrap justify-between content-center -mx-2 p-8"
            >
              <div class="w-full md:w-1/4 px-2">
                <v-text-field
                  :disabled="editedIndex !== -1"
                  outlined
                  v-model="editedItem.violation_type"
                  label="Violation Type"
                  hint="Violation Type"
                ></v-text-field>
              </div>
              <div class="w-full md:w-1/4 px-2">
                <v-text-field
                  outlined
                  v-model="editedItem.violation_label"
                  label="Violation Label"
                  hint="Violation Label"
                ></v-text-field>
              </div>
              <div class="w-full md:w-1/4 px-2">
                <v-text-field
                  outlined
                  v-model="editedItem.violation_desc"
                  label="Violation Description"
                  hint="Violation Description"
                ></v-text-field>
              </div>
              <div class="w-full md:w-1/4 px-2">
                <v-text-field
                  outlined
                  v-model="editedItem.ticket_prices"
                  label="Ticket Price"
                  hint="Ticket Price"
                ></v-text-field>
              </div>
              <div class="w-full md:w-1/4 px-2">
                <v-select
                  :items="dropdownActiveFlagOption"
                  outlined
                  v-model="editedItem.is_active_flag"
                  item-text="text"
                  item-value="value"
                  label="Active Flag?"
                ></v-select>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="close"
            ><v-icon>cancel</v-icon>Cancel</v-btn
          >
          <v-btn :loading="loadingSubmitButton" color="success" @click="save"
            ><v-icon>mdi-check</v-icon>Submit</v-btn
          > </v-card-actions
        >>
      </v-card>
    </v-dialog>

    <v-card raised>
      <v-card-title>
        Violation Ticket Type
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn color="primary" outlined @click="dialog = true">
          <v-icon class="mr-2">add_circle_outline</v-icon>
          Add Ticket Type
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :loading="loadingTicketTypes"
          :headers="headers"
          :items="violationTicketType"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      appURL: process.env.MIX_APP_URL,
      loadingTicketTypes: false,
      loadingSubmitButton: false,
      violationTicketType: [],
      dialog: false,
      snack: false,
      snackColor: "",
      snackText: "",
      headers: [
        {
          text: "Violation Type",
          align: "left",
          sortable: true,
          value: "violation_type",
        },
        { text: "Violation Label", value: "violation_label" },
        { text: "Violation Description", value: "violation_desc" },
        { text: "Price", value: "ticket_prices" },
        { text: "Active?", value: "is_active_flag" },
        { text: "Actions", value: "action", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        violation_type: "",
        violation_label: "",
        violation_desc: "",
        ticket_prices: "",
        is_active_flag: "",
      },
      defaultItem: {
        violation_type: "",
        violation_label: "",
        violation_desc: "",
        ticket_prices: "",
        is_active_flag: "",
      },
      dropdownActiveFlagOption: [
        { text: "Yes", value: "Y" },
        { text: "No", value: "N" },
      ],
    };
  },
  created() {
    this.fetchViolationTicketType();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit";
    },
  },
  methods: {
    fetchViolationTicketType: function () {
      this.loadingTicketTypes = true;
      axios
        .get(this.appURL + "/api/tickettype")
        .then((response) => {
          if (response.status === 200) {
            this.violationTicketType = response.data;
          }
          this.loadingTicketTypes = false;
        })
        .catch((error) => {
          this.loadingTicketTypes = false;
        });
    },
    save: function () {
      if (this.editedIndex > -1) {
        //Update
        this.loadingSubmitButton = true;
        axios
          .post(
            this.appURL + "/api/tickettype/" + this.editedItem.violation_type,
            {
              _method: "patch",
              violation_type: this.editedItem.violation_type,
              violation_label: this.editedItem.violation_label,
              violation_desc: this.editedItem.violation_desc,
              ticket_prices: this.editedItem.ticket_prices,
              is_active_flag: this.editedItem.is_active_flag,
            }
          )
          .then((response) => {
            if (response.status === 200) {
              Object.assign(
                this.violationTicketType[this.editedIndex],
                this.editedItem
              );
              this.snack = true;
              this.snackColor = "success";
              this.snackText = "Successfully Updated";
            } else {
              this.snack = true;
              this.snackColor = "error";
              this.snackText = "Oops! Something went wrong!";
            }
            this.loadingSubmitButton = false;
            this.close();
          })
          .catch((error) => {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Oops! Something went wrong!";
            this.loadingSubmitButton = false;
            this.close();
          });
      } else {
        //Save
        this.loadingSubmitButton = true;
        axios
          .post(this.appURL + "/api/tickettype/", {
            violation_type: this.editedItem.violation_type,
            violation_label: this.editedItem.violation_label,
            violation_desc: this.editedItem.violation_desc,
            ticket_prices: this.editedItem.ticket_prices,
            is_active_flag: this.editedItem.is_active_flag,
          })
          .then((response) => {
            if (response.status === 200) {
              this.violationTicketType.push(this.editedItem);
              this.snack = true;
              this.snackColor = "success";
              this.snackText = "Successfully Added";
            }
            this.loadingSubmitButton = false;
            this.close();
          })
          .catch((error) => {
            if (error.response.status === 404) {
              this.snack = true;
              this.snackColor = "error";
              this.snackText = error.response.data.message;
              this.loadingSubmitButton = false;
            } else {
              this.snack = true;
              this.snackColor = "error";
              this.snackText = "Oops! Something went wrong!";
              this.loadingSubmitButton = false;
            }
            this.close();
          });
      }
    },
    editItem(item) {
      this.editedIndex = this.violationTicketType.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
